export const SIDE_NAV_WIDTH = 295
export const SIDE_NAV_WIDTH_COLLAPSED = 68
export const SIDE_NAV_HEADER_CLASS_NAME = 'side-nav-header'
export const SIDE_NAV_PIN_BUTTON_CLASS_NAME = 'side-nav-header-pin-button'
export const SIDE_NAV_GUIDANCE_ITEM_CLASS_NAME = 'side-nav-guidance-item'
